<template>
    <div>
        <div class="s_1280">
            <!-- top panel -->
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-4">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-8">
                    <div class="app navigation">
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>

            <div class="main registration reg">
                <div class="container-fluid wrapper">

                    <div class="row reg-box">

                        <div class="col-5">

                            <h1>Registration</h1>
                            <p>You're travelling; itinerary planned, bags packed, and ready to board! But have you checked whether you need a tourist visa, or require a travel document?</p>

                        </div>

                        <div class="col-7">
                            <div class="reg-form">
                                <form v-if="!formSaved" class="k-form" @submit="handleSubmit" novalidate="true" autocomplete="off">

                                    <!-- Surname -->
                                    <div class="form-group row">

                                        <label for="surname" class="col-sm-4 col-form-label">1. Surname</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="surname" class="form-control" v-model="model.LastName" @keypress="isLetterOfName($event)" maxlength="40">
                                        </div>

                                    </div>

                                    <!-- First name -->
                                    <div class="form-group row">
                                        <label for="firstname" class="col-sm-4 col-form-label">2. First name</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="firstname" class="form-control" v-model="model.FirstName" @keypress="isLetterOfName($event)" maxlength="50">
                                        </div>
                                    </div>

                                    <!-- Middle name -->
                                    <div class="form-group row">
                                        <label for="middlename" class="col-sm-4 col-form-label">3. Middle name</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="middlename" class="form-control" v-model="model.MiddleName" @keypress="isLetterOfName($event)" maxlength="40">
                                        </div>
                                    </div>

                                    <!-- birth date -->
                                    <div class="form-group row">
                                        <label for="brthdate" class="col-sm-4 col-form-label">4. Date of birth</label>
                                        <div class="col-sm-8">

                                            <datepicker v-model="model.BirthDate"
                                                        :name="'dob'"
                                                        class="form-control no-blue"
                                                        :min="minDOB" :max="getToday"
                                                        :label="'Date of Birth'"
                                                        :placeholder="'Date of Birth'"
                                                        :format="'dd/MM/yyyy'"
                                                        :required='true' />

                                        </div>
                                    </div>

                                    <!-- passport number -->
                                    <div class="form-group row">
                                        <label for="passportnum" class="col-sm-4 col-form-label">5. Passport number</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="passportnum" class="form-control upper" v-model="model.PassportNo" @keypress="isLetterOfPassportNumber($event)" maxlength="9">
                                        </div>
                                    </div>

                                    <!-- expiry date -->
                                    <div class="form-group row">
                                        <label for="expirydate" class="col-sm-4 col-form-label">6. Passport expiry date</label>
                                        <div class="col-sm-8">

                                            <datepicker v-model="model.PassportExpiryDate"
                                                        :name="'passExpiryDate'"
                                                        class="form-control no-blue"
                                                        :min="getToday" :max="getTodayPlus20"
                                                        :label="'Passport Expiry Date'"
                                                        :placeholder="'Passport Expiry Date'"
                                                        :format="'dd/MM/yyyy'"
                                                        :required='true' />
                                        </div>

                                    </div>

                                    <!-- nationality -->
                                    <div class="form-group row">
                                        <label for="nationality" class="col-sm-4 col-form-label">7. Nationality</label>
                                        <div class="col-sm-8">
                                            <kendo-combobox v-model="model.Nationality"
                                                            :data-source="countries"
                                                            :name="'Country'"
                                                            id="nationality"
                                                            class="form-control no-blue"
                                                            :placeholder="'Nationality...'"
                                                            :data-text-field="'Description'"
                                                            :data-value-field="'Code'"
                                                            :filter="'contains'"
                                                            @cascade="onNationalityChanged"
                                                            :required="true"
                                                            :filter-fields="['Description']" />
                                        </div>
                                    </div>

                                    <!-- visa type -->
                                    <div class="form-group row">
                                        <label for="visatype" class="col-sm-4 col-form-label">8. Type of Visa required</label>
                                        <div class="col-sm-8">
                                            <kendo-combobox v-model="model.VisaCategory"
                                                            :data-source="visacategories"
                                                            :name="'VisaCategory'"
                                                            id="visatype"
                                                            class="form-control no-blue"
                                                            :placeholder="'Select visa type...'"
                                                            :data-text-field="'Description'"
                                                            :data-value-field="'Code'"
                                                            :filter="'contains'"
                                                            :required="true"
                                                            @cascade="onVisaTypeChanged"
                                                            :filter-fields="['name']" />
                                        </div>
                                    </div>

                                    <!-- number of entries -->
                                    <div class="form-group row">
                                        <label for="entries" class="col-sm-4 col-form-label">9. Number of entries</label>
                                        <div class="col-sm-8">
                                            <kendo-combobox v-model="model.VisaType"
                                                            :data-source="visatypes"
                                                            :name="'VisaType'"
                                                            id="entries"
                                                            class="form-control no-blue"
                                                            :placeholder="'Select No. of entries...'"
                                                            :data-text-field="'Description'"
                                                            :data-value-field="'Code'"
                                                            :filter="'contains'"
                                                            :required="true"
                                                            @cascade="onVisaCategoryChanged"
                                                            :filter-fields="['name']" />
                                        </div>

                                    </div>

                                    <!-- requested length of stay -->
                                    <div class="form-group row">
                                        <label for="entries" class="col-sm-4 col-form-label">10. Proposed length of stay</label>
                                        <div class="col-sm-4">
                                            <input type="number" id="entries" class="form-control width-200" min="1" step="1" v-model.number="model.LengthOfStay" @keydown="isNotDot($event)">
                                        </div>
                                        <div class="col-sm-4">
                                            <label>days</label>
                                        </div>
                                    </div>

                                    <!-- email -->
                                    <div class="form-group row">
                                        <label for="email" class="col-sm-4 col-form-label">11. Email</label>
                                        <div class="col-sm-8">
                                            <input type="email" id="email" class="form-control" v-model="model.EMail">
                                        </div>
                                    </div>

                                    <!-- captcha -->
                                    <div class="form-group row">
                                        <div class="col-sm-4">
                                        </div>
                                        <div class="col-sm-8 left40">
                                            <div class="captcha">
                                                <input type="checkbox" v-model="captcha" class="form-check-input" id="captcha">
                                                <label class="form-check-label" for="captcha">I'm not a robot</label>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- terms and conditions -->
                                    <div class="form-group row">
                                        <div class="col-sm-12">
                                            <div class="terms">
                                                <input type="checkbox" v-model="conditions" class="form-check-input" id="conditions">
                                                <a @click="show" class="terms-link">I hereby acknowledge that I have read, understand and agree to the terms and conditions.</a>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- submit-->


                                    <div class="reg-div"></div>

                                    <div class="form-group row">
                                        <div class="col-sm-12 submit-row">
                                            <button type="submit" class="btn-submit">Continue</button>
                                        </div>
                                    </div>

                                    <!-- errors area -->
                                    <div class="form-group row remark" v-if="errors.length">
                                        <div class="col-sm-3">
                                            <div class="red-astr"></div>
                                            <div class="error">These fields contain errors</div>
                                        </div>
                                        <div class="col-sm-9">
                                            <div class="err-desc" v-for="error in errors">
                                                <span>{{ error }}</span>
                                            </div>
                                        </div>
                                    </div>

                                </form>


                                <div v-else class="reg-completed">
                                    <div class="form-group row">
                                        <h2>Registration is complete!</h2>
                                        <p>Your application number is</p>
                                        <h3>{{result.AppId}}</h3>
                                        <p>Make sure you save this number for future refence</p>
                                    </div>

                                    <div class="reg-div"></div>

                                    <div class="form-group row">
                                        <p>Click Payment to go to the next step</p>
                                        <div class="col-sm-12 submit-row">
                                            <router-link to="/prepayment">
                                                <button type="submit" class="btn-submit">Payment</button>
                                            </router-link>
                                        </div>
                                    </div>

                                </div>


                            </div>  <!-- reg-form top98 -->
                        </div>   <!-- col-7-->

                    </div> <!-- row reg-box -->

                </div> <!-- container-fluid wrapper -->
            </div> <!-- main registration reg -->
            
        </div>

            <modal name="hello-world"
                   :width="800"
                   :height="640">
                <div class="modal-form">
                    <h3>Terms and Conditions</h3>
                    <p>The following provisions apply to all applicants who have opted for or intending to opt for services at the  Visa application Centre in Gaborone, and  all Botswana consulates across the world. </p>
                    <p>Applicants acknowledge that the Botswana visa office responsible for the world reserves the right to request for additional documentation or interview in order to make a decision on visa applications.</p>
                    <p>The applicant will be required to fill in a Visa application form accurately and submit the same with the applicable Visa fees, valid passport and necessary documentation as specified in the visa application form. Applicants must hold valid travel documents and comply with the requirements of the government of the Republic of Botswana.</p>
                    <p>The decision to grant or refuse a Visa is the sole prerogative of the government of Botswana. In case of rejection of Visa application, no correspondence will be entertained and no Visa fees will be refunded and no reasons will be required to be given.</p>
                    <p>Visa fees are non-refundable under any circumstances whatsoever.</p>
                    <p>Any charges for services availed by applicants are non-refundable.</p>
                    <p>Issuance of a visa or approval on the visa application does not in any way give the applicant/passenger a right to Botswana. The entry is at the sole discretion of the Immigration officer at any point of entry into the country who is a representative of the Government of the Republic of Botswana.</p>
                    <p>The Visa must be accepted as offered and non- transferable.</p>
                    <p>The Visa is valid as per the government of the Republic of Botswana rules and regulations as amended from time to time. The Visa must be availed within its period of validity.</p>
                    <p>Applicant will be solely responsible to ensure they fulfill Botswana government requirements for travel which may include police clearance e.t.c</p>
                    <p>Applicants expressly declare that they do understand these terms & conditions and are individuals and not a company or any professional and or commercial entity.</p>

                    <div class="submit-row bt48">
                        <button @click="hide" type="button" class="btn-submit">Close</button>
                    </div>
                </div>
            </modal>

        <div class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64 bt48">
                    <h2 class="bt-24">Registration</h2>
                    <p>You're travelling; itinerary planned, bags packed, and ready to board! But have you checked whether you need a tourist visa, or require a travel document?</p>

                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="reg-form">
                        <form v-if="!formSaved" class="k-form" @submit="handleSubmit" novalidate="true" autocomplete="off">

                            <!-- Surname -->
                            <div class="form-group row">

                                <label for="surname" class="col-sm-4 col-form-label">1. Surname</label>
                                <div class="col-sm-8">
                                    <input type="text" id="surname" class="form-control" v-model="model.LastName" @keypress="isLetterOfName($event)" maxlength="40">
                                </div>

                            </div>

                            <!-- First name -->
                            <div class="form-group row">
                                <label for="firstname" class="col-sm-4 col-form-label">2. First name</label>
                                <div class="col-sm-8">
                                    <input type="text" id="firstname" class="form-control" v-model="model.FirstName" @keypress="isLetterOfName($event)" maxlength="50">
                                </div>
                            </div>

                            <!-- Middle name -->
                            <div class="form-group row">
                                <label for="middlename" class="col-sm-4 col-form-label">3. Middle name</label>
                                <div class="col-sm-8">
                                    <input type="text" id="middlename" class="form-control" v-model="model.MiddleName" @keypress="isLetterOfName($event)" maxlength="40">
                                </div>
                            </div>

                            <!-- birth date -->
                            <div class="form-group row">
                                <label for="brthdate" class="col-sm-4 col-form-label">4. Date of birth</label>
                                <div class="col-sm-8">

                                    <datepicker v-model="model.BirthDate"
                                                :name="'dob'"
                                                class="form-control no-blue"
                                                :min="minDOB" :max="getToday"
                                                :label="'Date of Birth'"
                                                :placeholder="'Date of Birth'"
                                                :format="'dd/MM/yyyy'"
                                                :required='true' />

                                </div>
                            </div>

                            <!-- passport number -->
                            <div class="form-group row">
                                <label for="passportnum" class="col-sm-4 col-form-label">5. Passport number</label>
                                <div class="col-sm-8">
                                    <input type="text" id="passportnum" class="form-control upper" v-model="model.PassportNo" @keypress="isLetterOfPassportNumber($event)" maxlength="9">
                                </div>
                            </div>

                            <!-- expiry date -->
                            <div class="form-group row">
                                <label for="expirydate" class="col-sm-4 col-form-label">6. Passport expiry date</label>
                                <div class="col-sm-8">

                                    <datepicker v-model="model.PassportExpiryDate"
                                                :name="'passExpiryDate'"
                                                class="form-control no-blue"
                                                :min="getToday" :max="getTodayPlus20"
                                                :label="'Passport Expiry Date'"
                                                :placeholder="'Passport Expiry Date'"
                                                :format="'dd/MM/yyyy'"
                                                :required='true' />
                                </div>

                            </div>

                            <!-- nationality -->
                            <div class="form-group row">
                                <label for="nationality" class="col-sm-4 col-form-label">7. Nationality</label>
                                <div class="col-sm-8">
                                    <kendo-combobox v-model="model.Nationality"
                                                    :data-source="countries"
                                                    :name="'Country'"
                                                    id="nationality"
                                                    class="form-control no-blue"
                                                    :placeholder="'Nationality...'"
                                                    :data-text-field="'Description'"
                                                    :data-value-field="'Code'"
                                                    :filter="'contains'"
                                                    @cascade="onNationalityChanged"
                                                    :required="true"
                                                    :filter-fields="['Description']" />
                                </div>
                            </div>

                            <!-- visa type -->
                            <div class="form-group row">
                                <label for="visatype" class="col-sm-4 col-form-label">8. Type of Visa required</label>
                                <div class="col-sm-8">
                                    <kendo-combobox v-model="model.VisaCategory"
                                                    :data-source="visacategories"
                                                    :name="'VisaCategory'"
                                                    id="visatype"
                                                    class="form-control no-blue"
                                                    :placeholder="'Select visa type...'"
                                                    :data-text-field="'Description'"
                                                    :data-value-field="'Code'"
                                                    :filter="'contains'"
                                                    :required="true"
                                                    @cascade="onVisaTypeChanged"
                                                    :filter-fields="['name']" />
                                </div>
                            </div>

                            <!-- number of entries -->
                            <div class="form-group row">
                                <label for="entries" class="col-sm-4 col-form-label">9. Number of entries</label>
                                <div class="col-sm-8">
                                    <kendo-combobox v-model="model.VisaType"
                                                    :data-source="visatypes"
                                                    :name="'VisaType'"
                                                    id="entries"
                                                    class="form-control no-blue"
                                                    :placeholder="'Select No. of entries...'"
                                                    :data-text-field="'Description'"
                                                    :data-value-field="'Code'"
                                                    :filter="'contains'"
                                                    :required="true"
                                                    @cascade="onVisaCategoryChanged"
                                                    :filter-fields="['name']" />
                                </div>

                            </div>

                            <!-- requested length of stay -->
                            <div class="form-group row">
                                <label for="entries" class="col-sm-4 col-form-label">10. Proposed length of stay</label>
                                <div class="col-sm-4">
                                    <input type="number" id="entries" class="form-control width-200" min="1" step="1" v-model.number="model.LengthOfStay" @keydown="isNotDot($event)">
                                </div>
                                <div class="col-sm-4">
                                    <label>days</label>
                                </div>

                            </div>

                            <!-- email -->
                            <div class="form-group row">
                                <label for="email" class="col-sm-4 col-form-label">11. Email</label>
                                <div class="col-sm-8">
                                    <input type="email" id="email" class="form-control" v-model="model.EMail">
                                </div>
                            </div>

                            <!-- captcha -->
                            <div class="form-group row">
                                <div class="col-sm-4">
                                </div>
                                <div class="col-sm-8 left40">
                                    <div class="captcha">
                                        <input type="checkbox" v-model="captcha" class="form-check-input" id="captcha">
                                        <label class="form-check-label" for="captcha">I'm not a robot</label>
                                    </div>
                                </div>
                            </div>

                            <!-- terms and conditions -->
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <div class="terms">
                                        <input type="checkbox" v-model="conditions" class="form-check-input" id="conditions">
                                        <a @click="show" class="terms-link">I hereby acknowledge that I have read, understand and agree to the terms and conditions.</a>
                                    </div>
                                </div>
                            </div>

                            <!-- submit-->


                            <div class="reg-div"></div>

                            <div class="form-group row">
                                <div class="col-sm-12 submit-row">
                                    <button type="submit" class="btn-submit">Continue</button>
                                </div>
                            </div>

                            <!-- errors area -->
                            <div class="form-group row remark" v-if="errors.length">
                                <div class="col-sm-3">
                                    <div class="red-astr"></div>
                                    <div class="error">These fields contain errors</div>
                                </div>
                                <div class="col-sm-9">
                                    <div class="err-desc" v-for="error in errors">
                                        <span>{{ error }}</span>
                                    </div>
                                </div>
                            </div>

                        </form>



                        <div v-else class="reg-completed">
                            <div class="form-group row">
                                <h2>Registration is complete!</h2>
                                <p>Your application number is</p>
                                <h3>{{result.AppId}}</h3>
                                <p>Make sure you save this number for future refence</p>
                            </div>

                            <div class="reg-div"></div>

                            <div class="form-group row">
                                <p>Click Payment to go to the next step</p>
                                <div class="col-sm-12 submit-row">
                                    <router-link to="/prepayment">
                                        <button type="submit" class="btn-submit">Payment</button>
                                    </router-link>
                                </div>
                            </div>

                        </div>


                    </div>  <!-- reg-form top98 -->
                </div>
            </div>
        </div>
    </div>
    

</template>

<script>

    const visaTypes = {
        NA: '0',
        Diplomatic: '2',
        Transit: '5',
        Official: '6',
        Employment: '7',
        Business: '8',
        Investment: '9',
        Tourist: '10',
        Visitor: '11',
        Study: '12'
    }

    const entries = {
        NA: '0',
        Single: '1',
        Multiple: '2'
    }

    import TopMenu from "./Menu";
    export default {
        name: 'NewVisa',
        components: {
            TopMenu
        },
        data: () => ({
            minDOB: new Date(1900, 1, 1),
            formSaved: false,
            formValid: false,
            model: {},
            result: {},
            passporttypes: [],
            visatypes: [],
            visacategories: [],
            countries: [],
            errors: [],
            captcha: false,
            conditions: false
        }),
        mounted() {
            this.getCountries()
            this.getPassportTypes()
            this.getVisaTypes()
            this.getVisaCategories()
        },
        computed: {
            confirmValid: function () {
                return this.password && this.password === this.confirmPassword;
            },
            getToday: function () {
                var timeElapsed = Date.now();
                var today = new Date(timeElapsed);
                today.setHours(0, 0, 0);
                return today;
            },
            getTodayPlus20: function () {
                var today = new Date();
                var year = today.getFullYear();
                var month = today.getMonth();
                var day = today.getDate();
                var todayPlus20 =  new Date(year + 20, month, day);
                return todayPlus20;
            }
        },
        methods: {
            onNationalityChanged(e) {
                var str = $('input[name ="Country_input"]').val();

                if (this.countries.find(x => x.Description === str) == null) {
                    this.cleanComboModel("Country_input", "nationality", this.model.Nationality);
                }
            },
            onVisaTypeChanged(e) {
                var str = $('input[name ="VisaCategory_input"]').val();

                if (this.visacategories.find(x => x.Description === str) == null) {
                    this.cleanComboModel("VisaCategory_input", "visatype", this.model.VisaCategory);
                }
            },
            onVisaCategoryChanged(e) {
                var str = $('input[name ="VisaType_input"]').val();

                if (this.visatypes.find(x => x.Description === str) == null) {
                    this.cleanComboModel("VisaType_input", "entries", this.model.VisaType);
                }
            },
            cleanComboModel(name,id,prop) {
                $('input[name ="'+name+'"]').val("");
                $("#"+id).val("");
                prop = "";
            },
            show() {
                this.$modal.show('hello-world');
            },
            hide() {
                this.$modal.hide('hello-world');
            },
            resetData: function (event) {
                this.errors.splice(0, this.errors.length)
            },
            isLetterOfName(e) {
                let char = String.fromCharCode(e.keyCode);
                var regex = /[a-zA-Z-' ]/;
                if (regex.test(char)) 
                    return true;
                else e.preventDefault();
            },
            isLetterOfPassportNumber(e) {
                let char = String.fromCharCode(e.keyCode);
                var regex = /[a-zA-Z0-9]/;
                if (regex.test(char))
                    return true;
                else e.preventDefault();
            },
            isNotDot(e) {
                if (e.key === '.') {
                    event.preventDefault();
                }
            },
            async getCountries() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/dictionary/nationalities')
                    const data = await response.json()
                    // remove Botswana from the list of countries
                    var countryOfBotwana = data.find(x => x.Code == "487");
                    var index = data.indexOf(countryOfBotwana);
                    data.splice(index, 1);
                    this.countries = data
                } catch (error) {
                    //console.error(error)
                }
            },
            async getPassportTypes() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/dictionary/passporttypes')
                    const data = await response.json()
                    this.passporttypes = data
                } catch (error) {
                    //console.error(error)
                }
            },
            async getVisaTypes() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/dictionary/visatypes')
                    const data = await response.json()
                    this.visatypes = data
                } catch (error) {
                    //console.error(error)
                }
            },
            async getVisaCategories() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/dictionary/visacategories')
                    const data = await response.json()
                    this.visacategories = data
                } catch (error) {
                    //console.error(error)
                }
            },
            async save() {
                try {
                    //console.log(this.model);
                    var status = kendo.jQuery('.status')
                    //console.log('saving')
                    this.model.PassportNo = this.model.PassportNo.trim().toUpperCase();
                    this.model.BirthDate = new Date(this.model.BirthDate.setHours(12, 0, 0));

                    //save
                    const response = await fetch(this.$apiip + '/api/v1/application/any', {
                        method: 'POST',
                        body: JSON.stringify(this.model),
                        headers: { 'Content-type': 'application/json; charset=UTF-8' },
                    })
                    const data = await response.json()
                    this.result = data
                    if (this.result.Status == 1) {

                        //const setck = await fetch(this.$apiip + '/api/v1/application/' + this.result.AppId + '/setCookie')
                        this.$cookie.set('eVisaAppID', this.result.AppId, 7);
                        //console.log('cookie set to ' + this.result.AppId);

                        this.formSaved = true
                    } else {
                        status.text('Oops! Application is not saved.')
                            .removeClass('alert-success')
                            .addClass('alert-danger')
                    }


                } catch (error) {
                    console.error(error)
                }
            },
            async handleSubmit(event) {
                //console.log('handle submit');
                event.preventDefault();
               /* var validator = this.kendoValidator
                var status = kendo.jQuery('.status')
                if (true) {  //(validator.validate()) {
                    status.text('Hooray! Your data is submitted!')
                        .removeClass('alert-danger')
                        .addClass('alert-success')
                    this.save()
                    this.success = true;
                    setTimeout(() => { this.success = false; }, 3000);
                } else {
                    status.text('Oops! There is invalid data in the form.')
                        .removeClass('alert-success')
                        .addClass('alert-danger')
                }*/
                this.errors = [];
                await this.validateData();
                //console.log('number of errors: ' + this.errors.length);

                if (this.errors.length == 0)
                    this.save();
            },
            async validateData() {
                if (!this.model.LastName) {
                    this.errors.push("1. Surname required.");
                } else {
                    if (this.model.LastName.length < 2 || this.model.LastName.length > 40) {
                        this.errors.push("1. Surname length must be between 1 to 40.");
                    }
                }
                if (!this.model.FirstName) {
                    this.errors.push("2. First name required.");
                } else {
                    if (this.model.FirstName.length < 2 || this.model.FirstName.length > 50) {
                        this.errors.push("2. First name length must be between 1 to 50.");
                    }
                }
                if (this.model.MiddleName) {
                    if (this.model.MiddleName.length < 2 || this.model.MiddleName.length > 40) {
                        this.errors.push("3. Middle name length must be between 1 to 40.");
                    }
                }
                if (!this.model.BirthDate) {
                    this.errors.push("4. Birth date is required.");
                } else {
                    if (Date.now() < this.model.BirthDate) {
                        this.errors.push("4. Birth date must be before today");
                    }
                }
                if (!this.model.PassportNo) {
                    this.errors.push("5. Passport No is required.");
                } else {
                    if (this.model.PassportNo.length < 6) {
                        this.errors.push("5. Passport length must be 6-9 characters.");
                    }
                }
                if (!this.model.PassportExpiryDate) {
                    this.errors.push("6. Passport expiration date is required.");
                } else {
                    if (this.model.BirthDate) {
                        if (this.model.PassportExpiryDate < this.model.BirthDate) {
                            this.errors.push("6. Expiry date must be later then date of birth.");
                        }
                    }
                    var today = new Date();
                    var todatPlus6Months = today.setDate(today.getDate() + 180);
                    if (this.model.PassportExpiryDate < todatPlus6Months) {
                        this.errors.push("6. Expiry date must be later than today plus 6 months.");
                    }
                }
                if (!this.model.Nationality) {
                    this.errors.push("7. Nationality is required.");
                }
                if (!this.model.VisaCategory) {
                    this.errors.push("8. Type of visa is required.");
                }
                if (!this.model.VisaType) {
                    this.errors.push("9. Number of entries is required.");
                }
                if (!this.model.LengthOfStay || this.model.LengthOfStay < 1) {
                    this.errors.push("10. Length of stay is required.");
                } else {
                    if (this.model.LengthOfStay > 9999) {
                        this.errors.push("10. Length of stay must be less than 9999.");
                    }
                }
                if (!this.model.EMail) {
                    this.errors.push("11. Email is required.");
                } else {
                    if (!this.validEmail(this.model.EMail)) {
                        this.errors.push("11. Valid email required.");
                    }
                }
                if (!this.conditions) {
                    this.errors.push("You must agree to terms and conditions to proceed the visa.");
                }
                if (!this.captcha) {
                    this.errors.push("You must not be a robot.");
                }

                /*if (this.model.VisaCategory == visaTypes.Employment) {

                    if (this.model.VisaType == entries.Multiple) {
                        if (this.model.LengthOfStay < 100) {
                            this.errors.push("10. Employment (multiple) visa length of stay must be more or equal than 100");
                        }
                    }
                }*/

                if (this.model.VisaCategory == visaTypes.Investment) {
                    if (this.model.VisaType == entries.Single) {
                        this.errors.push("10. Investment visa must be multiple only");
                    }
                    if (this.model.VisaType == entries.Multiple) {
                        if (this.model.LengthOfStay > 1850) {
                            this.errors.push("10. Investment (multiple) visa length of stay must be less or equal than 1850");
                        }
                    }
                }

                if (this.model.VisaCategory == visaTypes.Tourist) {
                    if (this.model.VisaType == entries.Single) {
                        if (this.model.LengthOfStay > 30) {
                            this.errors.push("10. Tourist (single) visa length of stay must be less or equal than 30");
                        }
                    }
                    if (this.model.VisaType == entries.Multiple) {
                        if (this.model.LengthOfStay > 90) {
                            this.errors.push("10. Tourist (multiple) visa length of stay must be less or equal than 90");
                        }
                    }
                }

                if (this.model.VisaCategory == visaTypes.Transit) {
                    if (this.model.VisaType == entries.Single) {
                        if (this.model.LengthOfStay > 7) {
                            this.errors.push("10. Transit (single) visa length of stay must be less or equal than 7");
                        }
                    }
                    if (this.model.VisaType == entries.Multiple) {
                        if (this.model.LengthOfStay > 1095) {
                            this.errors.push("10. Transit (multiple) visa length of stay must be less or equal than 1095");
                        }
                    }
                }

                if (this.model.VisaCategory == visaTypes.Business) {
                    if (this.model.VisaType == entries.Single) {
                        if (this.model.LengthOfStay > 90) {
                            this.errors.push("10. Business (single) visa length of stay must be less or equal than 90");
                        }
                    }
                    if (this.model.VisaType == entries.Multiple) {
                        if (this.model.LengthOfStay > 1095) {
                            this.errors.push("10. Transit (multiple) visa length of stay must be less or equal than 1095");
                        }
                    }
                }

                if (this.model.VisaCategory == visaTypes.Visitor) {
                    if (this.model.VisaType == entries.Single) {
                        if (this.model.LengthOfStay > 90) {
                            this.errors.push("10. Visitor (single) visa length of stay must be less or equal than 90");
                        }
                    }
                    if (this.model.VisaType == entries.Multiple) {
                        if (this.model.LengthOfStay > 730) {
                            this.errors.push("10. Visitor (multiple) visa length of stay must be less or equal than 730");
                        }
                    }
                }

                // after all has been checked, we do a server check 
                if (this.errors.length == 0) {
                    var visaNotRequired = this.countries.find(item => item.Code == this.model.Nationality).VisaNotRequired;
                    //console.log('visa not required: ' + visaNotRequired);
                    if (visaNotRequired == 'Y') {
                        try {
                            var url = `${this.$apiip}/api/v1/application/${this.model.Nationality}/${this.model.PassportNo}/isobliged`;
                            const response = await fetch(url);
                            const data = await response.json();
                            //console.log(`person in obliged table: ${data}`);
                            if (data == 0) {
                                var countryName = this.countries.find(item => item.Code == this.model.Nationality).Description;
                                var errormsg = `7. Visitors from ${countryName} are not required to apply for a visa`;
                                this.errors.push(errormsg);
                            }
                        }
                        catch (error) {
                            console.error(error)
                        }
                    }
                }
            },
            validEmail: function (email) {
                var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            }
        }
    }
</script>

<style scoped>
  
</style>